function collectAttributes(regExp, str) {
  const matches = [];
  // eslint-disable-next-line
  while (true) {
    const match = regExp.exec(str);
    if (match === null || typeof match[0] === "undefined") break;
    matches.push([match[2], match[3]]);
  }
  return matches;
}

export default () => [
  {
    regex: /\{\{media url="(.*?)"\}\}/gi,
    replacement: (match, url) => `/media/${url}`,
  },
  {
    regex: /\{\{media url=&quot;(.*?)&quot;\}\}/gi,
    replacement: (match, url) => `/media/${url}`,
  },
  {
    regex: /\{\{media url=(.*?)\}\}/gi,
    replacement: (match, url) => `/media/${url}`,
  },
  {
    regex: /\{\{store (?:url|direct_url)="(.*?)"\}\}/gi,
    replacement: (match, url) => `/${url}`,
  },
  {
    regex: /{{widget( +(=?[^= ]+(="[^"]*")?) *)+}}/gi,
    replacement: (widget) => {
      const attributes = collectAttributes(/( ([^ =]*)="([^"]*)")/g, widget);

      const attributesString = attributes
        .map(([name, value]) => {
          return `${name.replace(/[=?>/\\]/g, "")}="${value
            .replace(/&/g, "&amp;")
            .replace(/'/g, "&apos;")
            .replace(/"/g, "&quot;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")}"`;
        })
        .join(" ");

      return `<widget ${attributesString}></widget>`;
    },
  },
  {
    regex: /\{\{.*?\}\}/gi,
    replacement: "",
  },
];
